import React from 'react'
import { useTranslation } from 'react-i18next'
import { Control, FieldErrors } from 'react-hook-form'
import { Typography } from '@material-ui/core'
import { ControlledTextField } from '../../../form/ControlledTextField'
import { validators } from '../../../../validation/validators'
import { InternalFormValues } from '../form-values'
import { FormGroup } from '../../../form/FormGroup'
import { powerUnit, temperatureUnit } from '../../../../util/formatters'

type Props = {
  control: Control<InternalFormValues>
  errors: FieldErrors<InternalFormValues>
}

export function HeatingAirHeatPumpForm({
  control,
  errors,
}: Props): React.ReactElement {
  const { t } = useTranslation()

  return (
    <>
      <FormGroup>
        <ControlledTextField
          control={control}
          name="parameters.heatingAirHeatPump.cop"
          rules={{
            ...validators.required,
            ...validators.cop,
          }}
          error={errors.parameters?.heatingAirHeatPump?.cop}
          label={t('createProvider.forms.heatingAirHeatPump.cop')}
          defaultValue="3"
        />
      </FormGroup>

      <FormGroup>
        <ControlledTextField
          control={control}
          name="parameters.heatingAirHeatPump.maxPower"
          rules={{
            ...validators.required,
            ...validators.maxPower,
          }}
          error={errors.parameters?.heatingAirHeatPump?.maxPower}
          label={t('createProvider.forms.heatingAirHeatPump.maxPower')}
          InputProps={{
            endAdornment: <Typography>{powerUnit}</Typography>,
          }}
        />
      </FormGroup>

      <FormGroup>
        <ControlledTextField
          control={control}
          name="parameters.heatingAirHeatPump.minOutdoorTemperature"
          rules={{
            ...validators.required,
            ...validators.decimal,
          }}
          error={errors.parameters?.heatingAirHeatPump?.minOutdoorTemperature}
          label={t(
            'createProvider.forms.heatingAirHeatPump.minOutdoorTemperature',
          )}
          defaultValue="-10"
          InputProps={{
            endAdornment: <Typography>{temperatureUnit}</Typography>,
          }}
        />
      </FormGroup>
    </>
  )
}
